import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
  
import { Prospect, Pays, Secteur } from '../entity/prospect';
 import { Contact } from '../entity/Contact';
import { ContactService } from './contact.service';
import { environment } from 'src/environments/environment.prod';
import { Observable } from 'rxjs';

import {MessageService} from 'primeng/api';
import { Client } from '../entity/exhibitor';
const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable()
export class ProspectService {
  replaceClass(arg0: string, arg1: string, arg2: string) {
    throw new Error("Method not implemented.");
  }


    private baseUrlCRM = environment.restApiCRM;
    private prospectUrlCRM = `${this.baseUrlCRM}prospect`;
    private baseUrl = environment.restApi;
    private prospectUrl = `${this.baseUrl}prospect`;
    private baseUrlERP = environment.restApiERP;
    private prospectUrlERP = `${this.baseUrlERP}prospect`;
   // private restApiERP2020 = `http://192.168.92.200:8082/financeBack-napec2020/webresources/participants`;

    
    constructor(
        private http: HttpClient,
        private messageService: MessageService,
        private contactService: ContactService,
   ) {
    }

    getProspectCrm(idProspect: number): Observable<any> {
        return this.http
            .get<Prospect>(`${this.prospectUrlCRM}/${idProspect}`)
            .pipe(
                tap(_ => this.notify('fetched prospect', 'GET')),
                catchError(this.handleError('getProspectCRM', 'GET'))
            );
    }



    

    getAllClientAncienErp(url:string ,isArchive:boolean): Observable<Client[]> {
        return this.http
            .get<Client[]>(`${url}participants/findALlIdNomTypeNoteMaj/${isArchive}`)
            .pipe(
                tap(_ => this.notify('fetched prospect', 'GET')),
                catchError(this.handleError('getProspectCRM', 'GET'))
            );
    }
    getClientAncienErp(url:string,idClient:number ): Observable<Client> {
        return this.http
            .get<Client[]>(`${url}participants/${idClient}`)
            .pipe(
                tap(_ => this.notify('fetched prospect', 'GET')),
                catchError(this.handleError('getProspectCRM', 'GET'))
            );
    }



    getCotactsCrm(idProspect: number): Observable<any> {
        return this.http
            .get<Contact[]>(`${this.prospectUrlCRM}/contacts/${idProspect}`)
            .pipe(
                tap(_ => this.notify('fetched prospect', 'GET')),
                catchError(this.handleError('getProspectCRM', 'GET'))
            );
    }



    getProspectErp(idProspect: number): Observable<any> {
        return this.http
            .get<Prospect>(`${this.prospectUrl}/${idProspect}`)
            .pipe(
                tap(_ => this.notify('fetched prospect', 'GET')),
                catchError(this.handleError('getProspectCRM', 'GET'))
            );
    }
    saveProspectErp(prospect: Prospect):Observable<any> {
 

        return this.http
            .put<Prospect>(`${this.prospectUrl}/${prospect.prospectId}`, prospect, httpOptions)
            .pipe(
                tap((prospect: Prospect) => this.notify(`editProspect w/ id=${prospect.prospectId}`, 'PUT')),
                catchError(this.handleError('editProspect', 'PUT'))
                
            );
    }




    createSecteurIfNotExiste(secteurStr: string):Observable<Secteur> {
         
        return this.http
            .post<Secteur>(`${this.baseUrl}secteur/createSecteurIfNotExiste/${secteurStr}` , httpOptions)
            .pipe(
                tap((secteur: Secteur) => this.notify(`editSecteur w/ id=${secteur.designation}`, 'post')),
                catchError(this.handleError('editSecteur', 'post'))
            );
    }
 
    //+'/'+peospect.prospectId
    saveProspectErpErp(prospect: Prospect):Observable<any> {
 

        return this.http
            .put<Prospect>(`${this.prospectUrlERP}/${prospect.prospectId}`, prospect, httpOptions)
            .pipe(
                tap((prospect: Prospect) => this.notify(`editProspect w/ id=${prospect.prospectId}`, 'PUT')),
                catchError(this.handleError('editProspect', 'PUT'))
                
            );
    }



    confirmProspect(idProspect: number) {
        this.getProspectCrm(idProspect).subscribe(result => {
            let prospect = this.copyProspect(result);
            this.saveProspectErpErp(prospect).subscribe(result => {
                this.getCotactsCrm(idProspect).subscribe(resultListContacts => {
                    let contacts: Contact[] = resultListContacts;
                    contacts.forEach(element => {
                        this.contactService.saveContact(element)
                    });
                })
            })




        })
    }

 

    copyProspect(result: Prospect): Prospect {
        let prospect = new Prospect();
        prospect.raisonSocial = result.raisonSocial;
        prospect.nrc = result.nrc;
        prospect.nai = result.nai;
        prospect.nif = result.nif;
        prospect.site = result.site;
        prospect.nrc = result.nrc;

        return prospect;

    }


    findPaysByDesignation(designationFr:string):Observable<Pays[]>{
    return this.http.get<Pays[]>(`${this.prospectUrl}/findPaysByDesignation/${designationFr}`)
    }


    /**
     * Prepare an error handler for failed HTTP requests.
     * That handler extracts the error message and logs it.
     * It also adds the message to the errors$ observable to which the caller
     * may listen and react.
     * @param operation The name/description of the operation that failed
     * @param method The HTTP method for the failed HTTP request
     */
    protected handleError(operation: string, method: string) {
        return function errorHandler(res: HttpErrorResponse) {
        
         //   this.logger.error(res);
           // const eMsg = res.message || '';
           /* const error = `${this.entityNamePlural} ${operation} Error${
                eMsg ? ': ' + eMsg : ''
                }`;*/
                this.messageService.add({severity:'error', summary:"Vous n'etes pas entrain d'ecrire", detail:"Veuillez contacter votre support"});
           
        }.bind(this);
    }

    protected notify(message: string, method: string) {

      //  this.messageService.add({severity:'success', summary:method, detail:message});
 
    }

}
